// swiper実行
// --- 最新のswiper v11ではループ時の不具合があるため、あえてv8を使用
document.addEventListener('DOMContentLoaded', function () {

  // 投稿スライダー（TOPなど）
  document.querySelectorAll('.js-article-slider').forEach(slider => {
    const swiper = new Swiper(slider, {
      speed: 600,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      slidesPerView: 1.2,
      spaceBetween: 20,
      centeredSlides: true,
      loopAdditionalSlides: 5,
      touchStartPreventDefault: false,

      // ブレークポイント（画面幅による設定）
      breakpoints: {
        // 画面幅が 768px 以上の場合（window width >= 768px）
        568: {
          slidesPerView: 2.2,
        },
        // 画面幅が 1024px 以上の場合（window width >= 1024px）
        769: {
          slidesPerView: 3.5
        }
      }
    });
  })

  // 投稿スライダー（事例紹介など）
  document.querySelectorAll('.js-article-card-slider').forEach(slider => {
    const swiper = new Swiper(slider, {
      speed: 600,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      slidesPerView: 1.2,
      spaceBetween: 20,
      centeredSlides: true,
      loopAdditionalSlides: 3,
      touchStartPreventDefault: false,
      pagination: {   // ページネーションの設定
        el: '.swiper-pagination',   // ページネーションラッパーのクラス
        type: 'bullets',   // ドットナビゲーション
        clickable: true,   // クリックしてスライド変更（初期値：false）
      },

      // ブレークポイント（画面幅による設定）
      breakpoints: {
        // 画面幅が 768px 以上の場合（window width >= 768px）
        568: {
          spaceBetween: 0,
          // slidesPerView: 1.2,
        },
        // 画面幅が 1024px 以上の場合（window width >= 1024px）
        769: {
          slidesPerView: 1.8,
          spaceBetween: 0,
        }
      }
    });
  })

  document.querySelectorAll('.c-serial-slider').forEach(slider => {
    const swiperEl = slider.querySelector('.js-serial-slider');
    const nextEl = slider.querySelector('.swiper-button-next');
    const prevEl = slider.querySelector('.swiper-button-prev');

    if (!swiperEl) return;

    new Swiper(swiperEl, {
      speed: 600,
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      touchStartPreventDefault: false,

      breakpoints: {
        568: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },

      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  });

  // 投稿スライダー（セミナーのバナースライダー）
  document.querySelectorAll('.js-bnr-slider').forEach(slider => {
    const swiper = new Swiper(slider, {
      speed: 600,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      slidesPerView: 1.2,
      spaceBetween: 20,
      centeredSlides: true,
      loopAdditionalSlides: 3,
      touchStartPreventDefault: false,
      pagination: {   // ページネーションの設定
        el: '.swiper-pagination',   // ページネーションラッパーのクラス
        type: 'bullets',   // ドットナビゲーション
        clickable: true,   // クリックしてスライド変更（初期値：false）
      },

      // ブレークポイント（画面幅による設定）
      breakpoints: {
        // 画面幅が 768px 以上の場合（window width >= 768px）
        569: {
          spaceBetween: 0,
          // slidesPerView: 1.2,
        },
        // 画面幅が 1024px 以上の場合（window width >= 1024px）
        769: {
          slidesPerView: 2.5,
          spaceBetween: 0,
        }
      }
    });
  })



})